import {
  HomePlaySvg,
  HomeAPPStore,
  HomeAPPScreen,
} from "../../../assets/img";
import Initial from "../../../helpers/Initial";


function About() {
  return (
    <section className="mid-wrap">
      <div className="pt-5 pb-5 kyc-form-block home-card-block">
        <div className="container">
          <div className="card form-card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="w-60 text-center">
                  <div className="hw-download-title">DOWNLOAD</div>
                  <div className="hc-logo text-center">
               
                    <img src={Initial?.branding?.logo} alt="main logo" />
                  </div>
                  <p>
                    Participate in and manage your {Initial?.organization?.title} Angel Fund startup
                    portfolio on our mobile application.
                  </p>
                  <div className="d-inline-flex align-items-center home-store-link">
                    <div>
                      <a href="#" target="_blank" rel="noreferrer">
                        <img src={HomePlaySvg} alt="google play" />
                      </a>
                    </div>
                    <div>
                      <a href="#" target="_blank">
                        <img src={HomeAPPStore} alt="app store" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="w-40 home-app-screen text-center">
                  <img src={HomeAPPScreen} alt="screen" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
